import { render, staticRenderFns } from "./ProjectEnergyCost.vue?vue&type=template&id=0f98f4b9&scoped=true&"
import script from "./ProjectEnergyCost.vue?vue&type=script&lang=js&"
export * from "./ProjectEnergyCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f98f4b9",
  null
  
)

export default component.exports